module.exports = __webpack_public_path__ + "static/media/Raghav.28b884ab.png";